import { Button, Grid, Input, InputGroup, InputLeftAddon, Select, Text, Flex, Image, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import classes from "./Profile.module.css"
import { useGlobalStore } from '../../store/globalStore'
import { isValidUserData } from '../../utils/usersHelper'
import { objEmptyStringsToNull, objReplaceNulls, toastError, toastSuccess } from '../../utils/globalHelper'
import UsersService from '../../API/UsersService'
import { useAccessAPI } from '../../hooks/useAccessAPI'

function Profile() {
    const [user, setUser] = useGlobalStore(state => [state.user, state.setUser])
    const [data, setData] = useState(user)
    const toast = useToast()
    const updateMyself = useAccessAPI(UsersService.updateMyself)

    useEffect(() => {
        setData(user)
    }, [user])

    const onBtn = async () => {
        if (!isValidUserData(data)) {
            toast(toastError(
                'Некорректные поля',
                'Фамилия и имя не могут быть пустыми, номер телефона должен содержать 10 цифр'
            ))
            return
        }

        const response = await updateMyself(objEmptyStringsToNull(data))
        if (response.status !== 200) {
            toast(toastError("Не удалось обновить данные"))
            return
        }

        setUser(objReplaceNulls(response.data))
        toast(toastSuccess("Данные профиля обновлены"))
    }

    const onPhoneInput = (event) => {
        if (event.target.value?.length <= 10)
            setData({...data, phone: event.target.value})
    }

    return (
        <Grid className={classes.container}>
            <Grid className={classes.form}>
                <Input
                    variant="filled"
                    placeholder='Фамилия'
                    value={data.lastname}
                    onChange={event => setData({...data, lastname: event.target.value})}
                />
                <Input
                    variant="filled"
                    placeholder='Имя'
                    value={data.firstname}
                    onChange={event => setData({...data, firstname: event.target.value})}
                />
                <Input
                    variant="filled"
                    placeholder='Отчество'
                    value={data.surname}
                    onChange={event => setData({...data, surname: event.target.value})}
                />
                <Input
                    variant="filled"
                    placeholder='Личная страница ВК'
                    type='number'
                    value={data.personal_vk}
                    onChange={event => setData({...data, personal_vk: event.target.value})}
                />
                <Input
                    variant="filled"
                    placeholder='Рабочая страница ВК'
                    type='number'
                    value={data.working_vk}
                    onChange={event => setData({...data, working_vk: event.target.value})}
                />
                <Input
                    variant="filled"
                    placeholder='Телеграм'
                    value={data.telegram}
                    onChange={event => setData({...data, telegram: event.target.value})}
                />
                <Input
                    variant="filled"
                    type='date'
                    value={data.birthday}
                    onChange={event => setData({...data, birthday: event.target.value})}
                />
                <InputGroup>
                    <InputLeftAddon>+7</InputLeftAddon>
                    <Input 
                        variant="filled"
                        placeholder='Номер телефона'
                        type='number'
                        value={data.phone}
                        onChange={onPhoneInput}
                    />
                </InputGroup>
                <hr/>
                <Flex gap="10px" alignItems="center">
                    <Text whiteSpace="nowrap">
                        Рабочий статус:
                    </Text>
                    <Select
                        placeholder='-'
                        value={data.status_id}
                        onChange={event => setData({...data, status_id: Number(event.target.value)})}
                    >
                        <option value={1}>Работаю</option>
                        <option value={2}>Не работаю</option>
                        <option value={3}>Отпуск</option>
                        <option value={4}>Выходной</option>
                    </Select>
                </Flex>
                <hr/>
                <Button onClick={onBtn}>
                    Сохранить изменения
                </Button>
            </Grid>
            <Image
                src={user.avatar ? user.avatar : 'avatar.png'}
                alt='Profile photo'
            />
        </Grid>
    )
}

export default Profile